import { gql } from '@apollo/client';

export default gql`
  mutation UpsertCustomPqProductName($input: UpsertCustomPqProductNamesInput!) {
    customPqProductName(input: $input)
  }
`;
